export const findClosestPoint = (points, userCoordinates) => {
  const degreesToRadians = (degrees) => (degrees * Math.PI) / 180

  // Precompute user's latitude and longitude in radians
  const [userLongitude, userLatitude] = userCoordinates
  const userLatitudeRad = degreesToRadians(userLatitude)
  const userLongitudeRad = degreesToRadians(userLongitude)

  const EARTH_RADIUS_KM = 6371

  let closestPoint = null
  let shortestDistance = Infinity

  for (const point of points) {
    const [pointLongitude, pointLatitude] = point.geometry.coordinates
    const pointLatitudeRad = degreesToRadians(pointLatitude)
    const pointLongitudeRad = degreesToRadians(pointLongitude)

    // Compute haversine distance directly
    const latitudeDifference = pointLatitudeRad - userLatitudeRad
    const longitudeDifference = pointLongitudeRad - userLongitudeRad

    const haversineFormula =
      Math.sin(latitudeDifference / 2) ** 2 +
      Math.cos(userLatitudeRad) *
        Math.cos(pointLatitudeRad) *
        Math.sin(longitudeDifference / 2) ** 2

    const distance = EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula)) // Earth's radius in kilometers

    if (distance < shortestDistance) {
      shortestDistance = distance
      closestPoint = { point, distance }
    }
  }

  return closestPoint
}

export const findPointByDistrictOrRegion = (points, district, region) => {
  // Search for a point in the specified district
  let point = points.find((point) => point.properties.district === district)

  // Fallback to searching by region if no point is found in the district
  if (!point) {
    point = points.find((point) => point.properties.region === region)
  }

  return point
}
